import { AwardWinners } from "./helper";

export const test = "";

export const FAQQuestions1 = [
  {
    question: "What is RIVA stands for?",
    answer: "Redington Interactive Virtual Assistant",
  },
  {
    question: "What RIVA Does?",
    answer:
      "RIVA, your dedicated Virtual Assistant, here to simplify and streamline all your HR-related inquiries. Feel free to ask me anything about leave, policies, insurance, benefits, PF, ESI, or any other concerns you may have. I am available to assist you, and just a click away.",
  },
  {
    question: "How to create a Ticket?",
    answer: "Create the ticket using the Others option.",
  },
  {
    question: "Showing wrong user name?",
    answer:
      "Go to the profile and choose not you to enter your employee code and submit the OTP that you're receiving in your official mail",
  },
];
export const FAQQuestions2 = [
  {
    question: "How to follow up with the ticket",
    answer: "You will receive mails for all the actions done by the HR Team",
  },
  {
    question: "Questions are not visible?",
    answer:
      "After selecting the menu, start typing the keyword in the textbox the available questions wil be populated",
  },
  {
    question: "Unable to create Ticket?",
    answer: "Kindly send a mail to Team ITNext(itnext.in@redingtongroup.com)",
  },
];

export const facts = [
  "You tend to blink your eyes about 20 times a minute, which equals ten million times a year.",
  "Our cornea, the transparent front part of the eyes, doesn’t get any blood supply and receives oxygen directly from the air!",
  "Did you know? A weird fact about the human body is that it consists of so much fat that it can make up to seven bars of soap.",
  "Once the oxygen supply is cut off, a human brain can survive up to three to six minutes.",
  "Humans develop fingertips from the time they were embryos, only three months after they are conceived. This means that just after the first trimester, the baby has fully developed fingertips.",
  "When a human blushes, they feel it in the lining of the stomach too as it also turns red.",
  "A weird fact about height is that when in space, astronauts can grow almost up to two inches.",
  "There are tumors known as teratomas, which can grow their own teeth and hair.",
  "Your heart can sync to the rhythm when you listen to music.",
  "Throughout their lifespan, humans go from having 300 bones to 206 bones.",
  "A human heart can beat outside the body as well.",
  "All humans are born with a diving reflex, which can shut bodily functions. This gets activated when one drowns or is submerged in the water.",
  "Humans can glow in the dark, however, they are too weak for the human eye to detect.",
  "The human body consists of organs in a singular count and pairs. However, the organs that are present in pairs, you only need one to survive.",
  "When your body experiences extreme starvation, there are chances that your brain will start to eat itself.",
  "Your small intestine is taller than you and measures about 23 feet.",
  "One-fourth of the bones in a human body are in the feet.",
  "When you calculate all the blood vessels in the human body, there are more than 100,00 miles of blood vessels present.",
  "If you were to check your height, you are taller in the morning compared to night.",
  "Did you know? You will not be able to breathe and swallow at the same time.",
  "Your right kidney is placed slightly lower than your left one.",
  "If you have heard about the term ‘pregnancy brain,’ know that it is completely real and not something that’s made up where a woman’s brain slightly shrinks.",
  "Ever wondered what the size of the brain is? If you smoothened out all the wrinkles, your brain would look flat like a pillowcase.",
  "The acid that’s generated in your stomach aka the stomach acid is so strong that it can even dissolve metal. So, it can even burn your skin",
  "Just like fingerprints, humans also possess a unique tongue print.",
  "Another weird fact about the human body is that we humans shed about 600,000 skin particles every hour.",
  "another one of the fun facts about humans. The human body is made of a trillion cells. And if there is a mutation in any of the cells, it can uncontrollably come together to form cancer. And when each cell is divided so many times with each one having almost 30,000 genes, there are chances that you might have fought cancer at one point.",
  "Did you know? Babies only blink once or twice in a minute while an adult blinks at least 10 times in the same time.",
  "In a lifetime, a human produces 25,000 quarts of saliva, which is enough to fill almost two swimming pools.",
  "One of the weird facts about the human body is that our lungs are the only organs that float on the water. This is because our lungs contain 300 million balloon-like structures known as alveoli.",
  "Even when we are in optimal health, our lungs are never sterile or germ-free.",
  "A wonderful yet weird fact about the human body is that our nose is almost a superhero. It is a filter, heater, and also a humidifier. So, the nose is lined with small bone-like shelves known as turbinates, which contain blood vessels that can heat the air and goblet cells that help humidify the air. Finally, the air you breathe is filtered before it goes to the lungs.",
  "Coughing and sneezing is the natural mechanism of your body to keep away any foreign substances.",
  "Children who don’t breathe from their nose but their mouth are at risk of developing a lisp when they talk.",
  "Did you know? Another weird fact about the human body is that whenever we eat something, the esophagus acts like a giant wave, which is known as peristalsis.",
  "So this one is a fun and weird fact about the human body. The second part of the intestine is known as the jejunum.",
  "Did you know? A bond exists between the digestive system and your brain, known as the gut-brain axis. So any stress or brain disorders can affect the way your body digests food.",
  "Another weird fact about the human body is that hiccups occur when the temperature changes.",
  "Another fun and weird fact about the brain is that the brain uses more energy than the rest of the organs where only 20% of the energy is reserved for the rest of the body.",
  "Your brain keeps working hard even when you are fast asleep.",
  "The density of the brain keeps increasing because of new neuronal connections that occur because the brain’s structure constantly keeps changing.",
  "Once you reach the age of 20, you start losing neurons and by the time you turn 75, at least 1/10 of the neurons are gone.",
  "The longest nerve of the body runs from the spinal cord to the toes of the body. This is known as the sciatic nerve.",
  "When we think of bones we think of hard substances. But another weird fact about the human body is the bones are filled with spongy substances known as bone marrow.",
  "The smallest bone in our body is in the inner ear.",
  "Now that you know the smallest, the longest bone in the body is the leg and it is also the strongest.",
  "Did you know? Your bone can heal itself by producing new cells. That’s why you are put in a cast when you fracture your bone.",
  "The biggest joint in your body is the knee.",
  "The human reproductive system contains the smallest and the largest human cells.",
  "In a weird fact about the human body, the longest recorded pregnancy went on to 375 days when a woman named Beulah Hunter gave birth in Los Angeles after 100 days of the average 280-day pregnancy.",
  "A fun fact about the human body is that it contains more than 600 muscles.",
  "The Gluteus Maximus, which is the main extensor muscle of the hip, is the largest muscle in the body.",
  "The smallest muscle of the body lies inside the inner ear and connects to the eardrum and your inner year together.",
  "More than 40% of your body weight is made of your muscles only.",
  "Do you want to know who is the hardest working muscle in your body? Well, it’s none other than the heart that pumps about 2,500 gallons of blood every day.",
  "A fun fact about your heart is that it beats about 100,000 times in a day.",
  "Did you know? The rate of heart attacks is higher on a Monday than on any other day of the week.",
  "In fun facts about the human body, the earliest known cause of heart disease was detected in an Egyptian mummy, which was 3,500 years old.",
  "A woman’s heart beats slightly faster when compared to a man's.",
  "The beating sound of the heart occurs because of the closing and opening of the heart’s valves.",
  "A fun and weird fact about the human body is that the brain is made up of 60% of fat.",
  "Did you know? Your brain is not fully formed until the age of 25.",
  "The brain’s storage capacity is unlimited as the brain consists of 86 billion neurons and these neurons form connections to others, rounding up to a total of 1,000 trillion.",
  "The information travels to your brain at a speed of 268 miles per hour.",
  "The brain weighs about 3 pounds whereas men tend to have a larger brain than women. However, the weight of the brain doesn’t imply intelligence.",
  "A weird fact about the human body is that a single square inch of skin has about 300 sweat glands.",
  "Your skin is home to more than 1,000 types of bacteria.",
  "The skin contributes to about 15% of your body weight.",
  "The thickest skin on your body is found in the feet while the thinnest is in the eyelids.",
  "Usually, when your body suffers from any medical condition, you will notice changes in the skin, which is a warning sign.",
  "One in every 2,000 babies is born with teeth. These are nothing but loose the teeth that can be sometimes removed by doctors as they can cause pain to new mothers.",
  "Teeth of babies tend to grow while they are in the womb itself, but only erupt when the child is within the age of 6 to 12.",
  "The average person spends 38.5 total days brushing their teeth over their lifetime.",
  "One-third of the teeth are underneath the gum.",
  "The tooth enamel is the part of the body, even harder than the bone.",
  "The human hand, along with the wrist contains 54 bones.",
  "Bones are made of an amalgamation of calcium, phosphorus, sodium, collagen, and other minerals.",
  "There are 26 bones in your foot.",
  "Bone is a living tissue, which means that every 7 years you have a new skeleton. And you need collagen to replenish the bones.",
  "Earwax is actually a type of sweat.",
  "The only letter that doesn’t appear on the periodic table is J.",
  "Back when dinosaurs existed, there used to be volcanoes that were erupting on the moon.",
  "In 2006, a Coca-Cola employee offered to sell Coca-Cola secrets to Pepsi. Pepsi responded by notifying Coca-Cola.",
  "The ten highest mountain summits in the United States are all located in Alaska.",
  "Daniel Radcliffe was allergic to his Harry Potter glasses. He had an allergy to nickel, and they were quickly replaced with hypoallergenic specs. did you know that his glasses had no lenses? This was to stop the reflection from anything happening behind the scenes. The glass lens was added in post-production.",
  "To leave a party without telling anyone is called in English a “French Exit.” In French, it’s called a “partir à l’anglaise,” to leave like the English.",
  "If you cut down a saguaro cactus in Arizona, you can be charged with a class-4 felony and penalized with jail time. ",
  "The Buddha commonly depicted in statues and pictures is a different person entirely. The real Buddha was actually incredibly skinny because of self-deprivation.",
  "In 2004, the Union Cabinet created a new category of languages known as classical languages, which would be based on certain criteria. Tamil was the first to be included in this. The criteria requirement was based on antiquity, a rich and varied ancient text and original literary tradition.",
];

export let iplMatch = [
  {
    id: "6606e633cbfe60cb474cd022",
    series_id: 2002,
    venue:
      "Dr. Y.S. Rajasekhara Reddy ACA-VDCA Cricket Stadium, Visakhapatnam (night)",
    date: "2024-04-03T14:00:00+00:00",
    status: "Fixture",
    result: "",
    match_title:
      "Delhi Capitals v Kolkata Knight Riders at Dr. Y.S. Rajasekhara Reddy ACA-VDCA Cricket Stadium, Visakhapatnam (night), T20.",
    match_subtitle: "16th Match",
    home: { id: 120252, name: "Delhi Capitals", code: "" },
    away: { id: 101751, name: "Kolkata Knight Riders", code: "KKR" },
  },
  {
    id: "6606e633cbfe60cb474cd023",
    series_id: 2002,
    venue: "Narendra Modi Stadium, Ahmedabad (night)",
    date: "2024-04-04T14:00:00+00:00",
    status: "Fixture",
    result: "",
    match_title:
      "Gujarat Titans v Punjab Kings at Narendra Modi Stadium, Ahmedabad (night), T20.",
    match_subtitle: "17th Match",
    home: {
      id: 161268,
      name: "Gujarat Titans",
      code: "",
    },
    away: {
      id: 145221,
      name: "Punjab Kings",
      code: "",
    },
  },
];

export const iplData = {
  "Mumbai Indians":
    "https://ssl.gstatic.com/onebox/media/sports/logos/JTre94vh6WJeLmIL-Dfc1g_96x96.png",
  "Royal Challengers Bangalore":
    "https://ssl.gstatic.com/onebox/media/sports/logos/f958HPOsI1ugsHmwc4piCw_96x96.png",
  "Chennai Super Kings":
    "https://ssl.gstatic.com/onebox/media/sports/logos/exZiFUT_GXScTyr358t7SQ_96x96.png",
  "Punjab Kings":
    "https://ssl.gstatic.com/onebox/media/sports/logos/HxbhoKfAgDZogey6S9E4bA_96x96.png",
  "Gujarat Titans":
    "https://ssl.gstatic.com/onebox/media/sports/logos/24uPDj4LAP1wpSEGHZWRDQ_96x96.png",
  "Rajasthan Royals":
    "https://ssl.gstatic.com/onebox/media/sports/logos/turpQqyPRIMvuksLiSDSjQ_96x96.png",
  "Kolkata Knight Riders":
    "https://ssl.gstatic.com/onebox/media/sports/logos/kkwGQB9t8WtGPx9WuiBGOw_96x96.png",
  "Lucknow Super Giants":
    "https://ssl.gstatic.com/onebox/media/sports/logos/b6uyRF-RX56muhQOv1-Z3A_96x96.png",
  "Delhi Capitals":
    "https://ssl.gstatic.com/onebox/media/sports/logos/TjudW-BaNE2HcD_6cOWC7Q_96x96.png",
  "Sunrisers Hyderabad":
    "https://ssl.gstatic.com/onebox/media/sports/logos/G9q07ZXPVbPkXOagStz3Yw_96x96.png",
};

export const images = {
  "Mumbai Indians": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/JTre94vh6WJeLmIL-Dfc1g_96x96.png",
    color: "#005FAA",
  },
  "Royal Challengers Bangalore": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/f958HPOsI1ugsHmwc4piCw_96x96.png",
    color: "#005FAA",
  },
  "Chennai Super Kings": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/exZiFUT_GXScTyr358t7SQ_96x96.png",
    color: "#FDB913",
  },
  "Punjab Kings": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/HxbhoKfAgDZogey6S9E4bA_96x96.png",
    color: "#A897AB",
  },
  "Gujarat Titans": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/24uPDj4LAP1wpSEGHZWRDQ_96x96.png",
    color: "#87CEEB",
  },
  "Rajasthan Royals": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/turpQqyPRIMvuksLiSDSjQ_96x96.png",
    color: "#EF2929",
  },
  "Kolkata Knight Riders": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/kkwGQB9t8WtGPx9WuiBGOw_96x96.png",
    color: "#4A245E",
  },
  "Lucknow Super Giants": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/b6uyRF-RX56muhQOv1-Z3A_96x96.png",
    color: "#0057E2",
  },
  "Delhi Capitals": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/TjudW-BaNE2HcD_6cOWC7Q_96x96.png",
    color: "#004C93",
  },
  "Sunrisers Hyderabad": {
    image:
      "https://ssl.gstatic.com/onebox/media/sports/logos/G9q07ZXPVbPkXOagStz3Yw_96x96.png",
    color: "#E65100",
  },
};

export const appreciations = [
  {
    id: 2,
    author: "Jagan Dayalababu",
    content: `Hi Ganesan ,
    We was connected the last DOA shipment for Feb’24.
    You and your team contribution is really commendable because last month we was connected 379 units in multiple dates even we faced many challenges with DHL but we accomplished with your team support especially @Kaviarasi E supported good by sharing VRPO’s on time and follow the vendors.
    Pl keep us support to clear all the back logs within our TAT.
    `,
    date: "March 03, 2024",
  },
  {
    id: 3,
    author: "Mohammed Fazi",
    content: `Dear Anuvin & Balanivas,
    Congratulations and hats off for the support during FY23-24!
    Writing this email with great a pride and pleasure! You both has been remarkable in terms of team support and the incredible coordination that has been executed during the year.
    Executing orders on time with proper follow-up from receiving PO till it delivered to partner, extremely pleased and proud of your achievements.    
    Sending timely backlog reports to partner with ETA’s and following internally with inbound, outbound, credit and all support functions.
    `,
    date: "April 01, 2024",
  },
  {
    id: 4,
    author: "Alex A",
    content: `Dear All,
    Thank you very much for the extraordinary support which you gave us for last few days without time boundary
    We have completed all our orders without any issue
    Once again thanks all for the support!!!
    `,
    date: "April 01, 2024",
  },
  {
    id: 5,
    author: "Nouman Latif",
    content: `Dear Team, I would like to take this opportunity to express my
  gratitude to COE Team for and great year. Also I want to
  congratulate you all on well-deserved success this year and
  next year as well.`,
    date: "April 02, 2024",
  },
  {
    id: 6,
    author: "Remya Mathew",
    content: `Dear Saranya&team,
    I personally want to express my gratitude to each and every one of you for your exceptional after-hours support. 
    I'm glad we all collaborated as a team and I hope we always will. 
    Again, thank you very much for all your amazing help! 
    `,
    date: "April 01, 2024",
  },
  {
    id: 7,
    author: "Neeraj Shrinarayan Tiwari",
    content: `Dear Dipika ,
    I like to appreciate your exceptional support provided today and during entire month . Thank you and looking forward for this kind of support in Future also.`,
    date: "March 31, 2024",
  },
  {
    id: 8,
    author: "Suchit Prasath",
    content: `Hi Vignesh ramesh,
    Thanks for your support over the Quarter/Year end for Inwarding the material on time 
    Your timely support on following for Invoices with Forex team, Inwarding the material helped to bill the Invoices on time to partners.
    We appreciate your hardwork till late night to get the work done.
    Kindly continue the same work and we expect the same kind of support in coming quarters also.`,
    date: "April 02, 2024",
  },
];

export const awardWinners: AwardWinners[] = [
  //india annual awards
  {
    id: 23,
    emp_name: "Jayashree A",
    department: "LFR/ Online - Outbound",
    description:
      "A skilled and talented leader and Subject Matter Expert in both Inbound and Outbound operations, consistently delivering exceptional results and fostering team growth and development.",
    heading: "Best Team Leader of the year Award",
  },
  {
    id: 24,
    emp_name: "Mohanrajrishi S",
    department: "Outbound",
    description:
      "He consistently displays strong process knowledge and commitment towards order processing & follow up activity. He is a role model for how a process executive should function to complete orders timely and accurately. He is a good trainer and has received many appreciation notes for her exemplary contribution",
    heading: "Best SPOC of the year Award",
  },
  {
    id: 25,
    emp_name: "Varshan M S B",
    department: "Outbound",
    description:
      "In recognition of meticulous attention to detail, unwavering commitment to QC. All-rounder with good knowledge of almost all brands in ESG and the go-to person for all team members to support on linearity days. Very rare issues reported for the orders he manged. He was the one the resources who had more than 99.9% within requested timeline.",
    heading: "Best QC of the year Award",
  },
  {
    id: 26,
    emp_name: "Cenita Sajji",
    department: "Outbound",
    description:
      "Handling high volumes during critical period with limited support and completing without any errors/escalations. She provides extended support for cross functional team when ever required.",
    heading: "Best Employee of the year Award",
  },
  {
    id: 27,
    emp_name: "Ravishangar P",
    department: "Outbound",
    description:
      "Great idea by Ravi to cut short the overall time to find out the orders getting rejected from various holds, Also to follow-up order pending at various hold. Using this idea BOT generated and used by almost all teams in the outbound process",
    heading: "Kaizen Award of the year",
  },
  {
    id: 28,
    emp_name: "Rajalakshmi Shanmugam",
    department: "Best Support – 3P",
    description:
      "Single-handedly manages operations, achieving zero client escalations, and effectively trains and coaches the team for outstanding performance, duly recognized by the client.",
    heading: "Best Support 3P of the year Award",
  },
  {
    id: 29,
    emp_name: "Rahul Swaminathan",
    department: "Best Support - Finance",
    description:
      "Rahul, a quick learner and technically adept, efficiently handles responsibilities, delivers high-quality work with minimal errors, and eagerly takes on new tasks, ensuring smooth completion with full dedication.",
    heading: "Best Support - Finance",
  },
  {
    id: 30,
    emp_name: "Arabinda Sahoo",
    department: "Best Support - IT",
    description:
      "Arabinda’s innovative approach for complicated processes and issues has not only resolved current challenges but also paved the way for future improvements and efficiencies.",
    heading: "Best Support - IT",
  },
  {
    id: 31,
    emp_name: "Johnson Johney",
    department: "Best Support - Admin",
    description:
      "Though there is many attrition during the entire year, Johnson have handled without any escalations or any issue.Ensured that all the admin related work pertains to Guindy locations have been handled properly.",
    heading: "Best Support - Admin",
  },
  //india data
  //inbound
  {
    id: 1,
    emp_name: "Ashwin Stenny A S",
    department: "Inbound",
    description:
      "He is a highly dedicated, organized, & efficient team player who consistently achieves exceptional results while focusing on continuous learning and improvement. In 4 months, He achieved 5746 nos. without any error and delivered on within timeline.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 2,
    emp_name: "Saravanakumar Pachaiappan",
    department: "Inbound",
    description:
      "Unwavering dedication, active involvement, and enthusiastic approach to learn and support multiple biz. Embodies the true spirit of collaboration within team.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 3,
    emp_name: "Navinraj J",
    department: "Inbound",
    description:
      "Demonstrates a remarkable sense of ownership over his work and its outcomes with dedication and sense of responsibility.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 4,
    emp_name: "Deepa Dharshini S",
    department: "Inbound",
    description:
      "Consistent performer, dedicated and flexible team player, always there for supporting team as and when required",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 5,
    emp_name: "Aravind Kumar M",
    department: "Inbound",
    description:
      "We thank you and appreciate your efforts towards providing amazing customer experience  in Migo Activity. His  contributions are invaluable to the success of our team",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 6,
    emp_name: "Manya Uppili",
    department: "Inbound",
    description:
      "Our sincere appreciation for the exceptional effort and dedication you have consistently demonstrated as a valued member of our team, keep up the fantastic work",
    heading: "Dazzling Star Award Q4",
  },
  //outbound india
  {
    id: 7,
    emp_name: "Mohammed Sajid Ali A",
    department: "Outbound",
    description:
      "Dedicated resource, always execute the order with high accuracy. He extends his support in most of the functions at Outbound wherever there is criticality.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 8,
    emp_name: "Raakesh Narendrababu",
    department: "Outbound",
    description:
      "Exhibits positivity, tackles critical orders, offers weekend and month-end support, demonstrates strong teamwork, coordination, and fast learning, while earning multiple appreciations from sales and business teams.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 9,
    emp_name: "R Santhoshini",
    department: "Outbound",
    description:
      "She is an exceptional team supporter, displaying unparalleled dedication and enthusiasm, readily available for assistance across various roles and stakeholders, demonstrating adaptability and commitment beyond shift hours.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 10,
    emp_name: "Yasar Arabath K",
    department: "Outbound",
    description:
      "Received recognition from the Branch for providing support to Channel Partners in processing multiple line items. Supported for other Biz Orders whenever necessary and Contributed to clearing orders from QC in accordance with management needs.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 11,
    emp_name: "Ravi Sankar Sampath",
    department: "Outbound",
    description:
      "Exemplifying excellence in every aspect, this top performer consistently exceeds expectations and delivers outstanding results. His dedication, precision, and proactive approach make him an invaluable asset to our team.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 12,
    emp_name: "Jayadev S",
    department: "Outbound",
    description:
      "A versatile and commendable resource proficient in order processing, managing holds, stock movement, timely invoicing, error education, and maintaining positive relationships with all ASM.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 13,
    emp_name: "Thivith S",
    department: "IND - Cloud",
    description:
      "A Subject Matter Expert who is aware of most of the MS Processes and also learning AWS & SAAS. Very quiet in approach but ensures to get the job done to client's satisfaction",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 14,
    emp_name: "Udaya Shankar Kumar",
    department: "IND – Credit & Fin.",
    description:
      "Supported PR release role in times of Adhoc requests and having good liaison with stake holders. Always been a good team player and willing to take additional tasks.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 15,
    emp_name: "Perumal",
    department: "IND – Credit & Fin.",
    description:
      "Transitioned CSR activity successfully and trained new resource on the same",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 16,
    emp_name: "Hari Parthasarathy",
    department: "IND – Credit & Fin.",
    description:
      "He has effectively and efficiently verified the documents/ approvals and raised the credit notes, 1250 interest entries,313 dealer payouts processed & Supporting to allocations/ cash applications on Q4 FY 2023-24. Received notes of appreciation from clients for his good work",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 17,
    emp_name: "Swathy S",
    department: "IND - Outbound",
    description:
      "A valuable team player who maximizes effectiveness, aids colleagues, and independently manages tasks, enabling field sales focus on the market, while ensuring seamless transactions through adept coordination for enhanced customer satisfaction.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 18,
    emp_name: "Manikandan P",
    department: "IND – LFR Online",
    description:
      "Having good rapport with vendor & Sales team . Dedicated and flexible team player. Good @handling MSG-Android LFR/Online billings.",
    heading: "Dazzling Star Award Q4",
  },
  //kaizen
  {
    id: 19,
    emp_name: "Sasikala R",
    department: "IND - Inbound",
    description:
      "240 Hrs per Quarter. She exemplify the essence of continuous improvement, demonstrating a relentless commitment to enhancing processes, driving innovation, and fostering a culture of excellence within our organization.",
    heading: "Best Kaizen Award",
  },
  {
    id: 20,
    emp_name: "Sivaprasad R",
    department: "IND - Inbound",
    description:
      "380 Hrs per Quarter. Sivaprasad’s unwavering dedication to continuous improvement truly embodies the spirit of Kaizen.",
    heading: "Best Kaizen Award",
  },
  {
    id: 21,
    emp_name: "Umayal Narayanan",
    department: "IND – Credit & Fin.",
    description:
      "Epson - Invoice conversion for IBD. Through her leadership and ingenuity, Umayal has inspired her colleagues and set a remarkable standard for excellence.",
    heading: "Best Kaizen Award",
  },
  {
    id: 22,
    emp_name: "Naveen Kumar V",
    department: "Software Engineer",
    description: "RIVA as a product launched by Naveen",
    heading: "Best Support Team Member",
  },
  //gulf annual
  {
    id: 52,
    emp_name: "Sai Venka Lakshmi",
    department: "Treasury",

    description:
      "Saivenkalakshmi is an exceptional team leader whose dedication , vision, and leadership has significantly contributed to the success and growth of her team. Her dedication, Passion, and ability to inspire, motivate makes her the ideal candidate for the Best Team Leader Award.",
    heading: "Best Team Leader of the year Award",
  },
  {
    id: 53,
    emp_name: "Srinath V",
    department: "OB Volume – Retail ME",

    description:
      "Srinath's outstanding performance in MSG (Samsung & Apple Business) is commendable, with his dedication and commitment streamlining team communication and enhancing operational efficiency. He efficiently processed 7408 line items, tracked 7618 orders, and conducted 1789 quality checks, showcasing his multitasking prowess and excellent interpersonal skills.",
    heading: "Best SPOC of the year Award",
  },
  {
    id: 54,
    emp_name: "Ranjeeth Kumar S",
    department: "Inbound Value",

    description:
      "A reliable team player, he ensures timely completion of SW order processes and exhibits strong accountability by meeting vendor deadlines. With a multifaceted role in COE, he conducts meticulous quality checks, manages Redhat business orders, and receives consistent positive feedback from the BO team.",
    heading: "Best QC of the year Award",
  },
  {
    id: 55,
    emp_name: "Vignesh R",
    department: "Inbound Volume",

    description:
      "Vignesh PSR's exceptional dedication and performance set a high standard, inspiring excellence in his colleagues. His meticulousness and commitment to quality earned him the Best Employee of the Year Award, a testament to his unmatched contribution to the team's success. Congratulations, Vignesh, and thank you for your invaluable contributions!",
    heading: "Best Employee of the year Award",
  },
  {
    id: 56,
    emp_name: "Anand Babu D",
    department: "CARA",

    description:
      "Anand seamlessly transitioned from a line role to GL Ownership of Africa Entities, leveraging over a decade of system experience to automate tasks and exceed stakeholder expectations, marking a smooth shift from individual contributor to leadership role.",
    heading: "Best Employee of the year",
  },
  {
    id: 57,
    emp_name: "Anand Jayaraman",
    department: "CARA",

    description: "",
    heading: "Special Recognition of the year",
  },
  {
    id: 58,
    emp_name: "Priyadharshini M",
    department: "Singapore Inbound",

    description:
      "She tackled the challenge of document management efficiently, saving significant time through automation. Her solution, utilizing macros, streamlined document preparation, saving 30 to 40 minutes per document, totaling 15 days saved over one quarter. Congratulations, Priyadharshini, on your impactful improvement!",
    heading: "Kaizen Award of the year",
  },
  {
    id: 59,
    emp_name: "Praveen Kumar K",
    department: "Outbound",

    description: "",
    heading: "COE Operations Excellence Award",
  },
  {
    id: 60,
    emp_name: "Venkatesan K",
    department: "Outbound",

    description: "",
    heading: "COE Operations Excellence Award",
  },

  // gulf data
  {
    id: 32,
    emp_name: "Chakravarthi BK",
    department: "Shipment Tracking",

    description:
      "Chakravarthy crushed his JFM goals, generating hundreds of documents (IBDNs) and shipments while flawlessly managing processes across regions. He also tackled issues in Oman like applying RC and secured potential payment extensions, exceeding expectations.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 33,
    emp_name: "Nanthini Palanivel",
    department: "Sellout Reporting",

    description:
      "Nanthini Palanivel, a diligent and dedicated individual, has successfully submitted over 180 monthly reports for Cisco and HPE brands, demonstrating a strong understanding of vendor reporting, ensuring timely submissions and support on weekends, making her a crucial part of the team.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 34,
    emp_name: "Prakash Reddy",
    department: "Order Placement",

    description:
      "Bhanu Prakash efficiently processed 447 PO's in Q4 2024, handling major brands like Lenovo-KSA, Hikvision, and Samsung, demonstrating dedication and teamwork in PCCR MDM processes.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 35,
    emp_name: "Pavithra K",
    department: "TSG",
    description:
      "A highly reliable and self-motivated team player. She possesses in-depth knowledge of QC processes. This quarter, she has consistently delivered faster TAT on critical OB orders. She has completed QC for 6575 orders in Q4 including the taxation compliance for all 13 entites.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 36,
    emp_name: "Keerthana J",
    department: "Fulfillment Team",
    description:
      "Keerthana J, a quick learner who adapts easily  handling fulfillment activities, transfer documents, and return requests, has generated the highest number 534 reversal documents and 397 traffic invoices for JFM month.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 37,
    emp_name: "Nanda Kumar R",
    department: "TSG",
    description:
      "He is an expert at getting 600 invoices in Q4 out on time. He works well with CRM and sales teams to make sure orders are correct and gets things moving smoothly. He has supported Billing across MEA.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 38,
    emp_name: "Nareshkumar Murali",
    department: "Corporate SPOC",
    description:
      "Naresh Kumar, a self-motivated individual, processed 532 sales orders and processed 3420 case IDs in JFM. Initially part of the retail order processing team, he quickly took on full responsibility for SPOC activities.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 39,
    emp_name: "Kamalesh P",
    department: "KSA OB Team",
    description:
      "Kamlesh from KSA operation achieved the highest credit note number of 433 in JFM, demonstrating his dedication and professionalism in managing retail accounts and ensuring smooth billing processes.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 40,
    emp_name: "Janani S",
    department: "CCP – Corporate/Retail",
    description:
      "Janani, a valuable asset to the Sales Coordination team, has successfully handled 133 CN creation requests, posted 272 cheque requests, and allocated 472 payments in the last quarter, demonstrating commitment and outstanding performance.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 41,
    emp_name: "Anish Kumar E",
    department: "Shipment Tracking",

    description:
      "He is a dedicated resource who provides round-the-clock support, handling CGF, CITRUS UAE, and CITRUS KSA regions, including audits, vendor payable recon, and remarkable Citrus revenue bookings, including trade vendor recon and consolidation.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 42,
    emp_name: "Dhakshinamoorthy Gopal",
    department: "Customer Finance",

    description:
      "Dedicated and hardworking resource, single handling of CN Process. Taken ownership in OGCC collection accounting and BRS reporting. Great support for Price rebate related audit requirements too. 734 Manual Credit notes Plus Incentive posting.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 90,
    emp_name: "Prasandh S",
    department: "Treasury",

    description:
      "He is handling UAE Service Vendor payouts, salary, and payments without errors, maintaining the TAT, processing OGCC payments, and handling in-country payments, taking ownership of the process and handling queries.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 43,
    emp_name: "Lakshmi Priya A",
    department: "Accounts Payable",

    description:
      "A dedicated resource with good rapport with in country team, taking ownership in ICPO entries, completing HP open items, closing old pending cases, CN upload, monthly debit balance recon, vendor recon, and COGS provision report..",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 44,
    emp_name: "Rajagopal S",
    department: "Finance – Business Accounts",

    description:
      "Over the past year, he effectively managed MSG business backend activities, including claim calculation, PG GM report finalization, and vendor receivables control, working closely with the business team.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 45,
    emp_name: "Abdur Rahman S",
    department: "Shipment Tracking",

    description:
      "In recognition of Abdur Rahman's exceptional leadership & expertise, he adeptly oversees the MDM team's management of Customer Onboarding, Refinitiv Portal, and Armstrong Portal responsibilities. His remarkable efforts, including handling over 4500 emails in Q4, earned him heartfelt appreciation from BO teams in the UAE & KSA regions for his pivotal year-end support.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 46,
    emp_name: "Athira Aswin",
    department: "RDPL Singapore",

    description:
      "She took complete ownership for GRN, Invoice process & AWB and she completes all the assigned tasks well within time. Got appreciation mail from Srilanka head",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 47,
    emp_name: "Aravind KA",
    department: "CARA - GL",

    description:
      "She took complete ownership for GRN, Invoice process & AWB and she completes all the assigned tasks well within time. Got appreciation mail from Srilanka head",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 48,
    emp_name: "Karthick M",
    department: "IT-Support",
    description:
      "Karthick has been pivotal in IT Asset tagging, ensuring prompt distribution to new employees and meticulous quarterly verifications. His leadership in E-waste dispatch, teamwork, and guidance in month-end activities have been invaluable.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 49,
    emp_name: "Chandrashekhar C",
    department: "BTIS",
    description:
      "Your initiative and dedication have gone above and beyond the call of duty, and we are truly impressed by the positive impact you've made.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 50,
    emp_name: "Kalyani N",
    department: "IT-Support",
    description:
      "Karthick has been pivotal in IT Asset tagging, ensuring prompt distribution to new employees and meticulous quarterly verifications. His leadership in E-waste dispatch, teamwork, and guidance in month-end activities have been invaluable.",
    heading: "Dazzling Star Award Q4",
  },
  {
    id: 51,
    emp_name: "Eswaran S",
    department: "Services",
    description:
      "Eswaran S has showcased remarkable skills in handling IBM and Acer Warranty orders. His proficiency in ETA Shipment tracking and his proactive approach in managing Hold & Rejections follow-up with the country team.",
    heading: "Dazzling Star Award Q4",
  },
];

export const moodScoreValues: any = {
  Frustrated: 0,
  Sad: 20,
  Ok: 40,
  Calm: 60,
  Happy: 80,
  "Very Happy": 100,
};
